import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';

const CheckboxGroup = ({
  label, name, options, input, meta: { touched, error },
}) => {
  const sortedOptions = options;
  const validationState = touched && error ? 'error' : null;
  return (
    <FormGroup validationState={validationState}>
      {label !== null && <ControlLabel>{label}</ControlLabel>}
      <div>
        {sortedOptions.map((option, index) => (
          <div className="checkbox-inline" key={option.value}>
            <ControlLabel>
              <input
                type="checkbox"
                name={`${name}[${index}]`}
                value={option.value || ''}
                checked={input.value.indexOf(option.value) !== -1}
                onChange={(event) => {
                  const newValue = [...input.value];
                  if (event.target.checked) {
                    newValue.push(option.value);
                  } else {
                    newValue.splice(newValue.indexOf(option.value), 1);
                  }
                  return input.onChange(newValue);
                }}
              />
              &nbsp;
              <span>{option.label}</span>
            </ControlLabel>
          </div>))}
      </div>
      {touched && error && <HelpBlock>{error}</HelpBlock>}
    </FormGroup>
  );
};
CheckboxGroup.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  input: PropTypes.shape({}),
  meta: PropTypes.shape({}),
};
CheckboxGroup.defaultProps = {
  label: null,
  name: null,
  options: [],
  input: null,
  meta: {},
};

export default CheckboxGroup;
